export default __webpack_public_path__ + "static/media/Skyfire.ed18d8ca.jpg";